"use strict";

(function (global) {
  /**
   * Функции отвечающие за работу с заданиями.
   * @namespace Core.jobs
   * @since 5.3.0.1010
   */
  global.jobs = {};
})(window.Core);

(function (global) {
  /**
   * Изменяет статус прочитанности заданий.
   * @description Задания помечаются непрочитанными, если все выбранные задания прочитаны. Иначе, все задания помечаются прочитанными.
   * @param {List} items Список элменетов, статус прочитанности которых требуется изменить.  
   */
  global.toggleReadStatus = function (items) {
    var jobs = _.filter(items, function (e) { return e.type === OBJECT_TYPE.JOB });
    var jobIds = _.map(jobs, function (e) { return e.id });
    var unreadJobs = _.filter(jobs, function (job) { return job.isUnread(); });
    var markAsRead = unreadJobs.length > 0;

    WA.services.call('/Job.asmx/MassMarkAsRead', { JobIDList: jobIds, MarkAsRead: markAsRead }).success(function (res) {
      var count = -unreadJobs.length;
      // Shirobokov_AV: Задания помечаются непрочитанными, если все выбранные задания прочитаны. Иначе, все задания помечаются прочитанными.
      if (!markAsRead) {
        count = jobs.length;
      }

      $.each(jobs, function (i, job) {
        if (markAsRead) {
          job.removeUnreadStyle();
        } else {
          job.addUnreadStyle();
        }
      });

      ChangeUnreadCountInTree(count);
    }).error(function (res) {
      (new WA.CMP.dialogs.MessageBox()).showError(res);
    });
  };
})(window.Core.jobs)